// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__25nwa","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3sQ4j"};